import { useQueryClient } from "@tanstack/react-query";
import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";

import { paths } from "../generated-types";

type Operation =
  paths["/dashboard/synota/contracts/{contract_shared_uuid}/last-energy-date"]["post"];
export type LastEnergyDateResult = Operation["responses"][200]["content"]["application/json"];
export type LastEnergyDateInput = Operation["parameters"]["path"] &
  Operation["requestBody"]["content"]["application/json"];

export function useContractLastEnergyDate(canSubmit: () => boolean) {
  const { client } = useHttp();
  const queryClient = useQueryClient();
  return useAxiosMfaMutation<LastEnergyDateResult, LastEnergyDateInput>(
    {
      mutationKey: ["set-contract-last-energy-date"],
      mutationFn: ({ contract_shared_uuid, ...input }) => {
        // A global MFA dialog may outlive the contract route that opened it.
        if (!canSubmit())
          return Promise.reject(new Error("Contract changed. Reopen the date editor."));
        return client.post(`/synota/contracts/${contract_shared_uuid}/last-energy-date`, input);
      },
      onSettled: (_data, _error, input) => {
        // A timeout or failed node request may still have persisted one copy.
        void queryClient.invalidateQueries({ queryKey: ["contracts"] });
        void queryClient.invalidateQueries({
          queryKey: ["contracts-details", { id: input.contract_shared_uuid }],
        });
      },
    },
    { modalTitle: "Verify last energy date change" },
  );
}
